import React from 'react';
import { connect } from 'react-redux';
import paging, { onCategoryScroll, reFetchConfig } from '@/hooks/paging';
import UsersPanelContainer, {
  mapDispatchToProps,
  mapStateToProps,
} from '../components/UsersPanelContainer';
import UserCards from '../components/UserCards';
import UsersFilters from './UsersFilters';

const UsersPanelNarrow = ({
  allowRoleLink,
  canRead,
  category,
  currentPage,
  fetchData,
  onCheckBoxClick,
  pageCount,
  pageSize,
  readErrors,
  readStatus,
  users,
  total,
}) => {
  paging.useFetchByCategory(fetchData, category, readStatus, reFetchConfig(users, { pageSize, total }));

  return (
    <UsersPanelContainer readErrors={readErrors} canRead={canRead} className="aridhia-users-panel-narrow">
      <UsersFilters category={category} className="sticky-panel-header" fluid />
      <UserCards
        allowApprovedStatus
        allowRoleLink={allowRoleLink}
        allowTools
        allowUserLink
        category={category}
        handleScroll={() => onCategoryScroll(fetchData, category, currentPage, pageCount, pageSize)}
        items={users}
        itemsPerRow={1}
        onCheckBoxClick={(value) => onCheckBoxClick(category, value)}
        readErrors={readErrors}
        readStatus={readStatus}
      />
    </UsersPanelContainer>
  );
};

export default connect(mapStateToProps, mapDispatchToProps)(UsersPanelNarrow);
